<script setup>
import { computed } from 'vue'

const props = defineProps({
  currentStep: {
    type: Number,
    required: true,
    default: 1
  }
})

const steps = [
  { number: 1, title: 'Personal Information', completedText: 'Completed' },
  { number: 2, title: 'Services Offered', completedText: 'Completed' },
  { number: 3, title: 'Pricing & Availability', completedText: 'Completed' },
  { number: 4, title: 'Bank Details', completedText: 'Completed' }
]

const isStepCompleted = (stepNumber) => props.currentStep > stepNumber
const isStepCurrent = (stepNumber) => props.currentStep === stepNumber
const isStepPending = (stepNumber) => props.currentStep < stepNumber
</script>

<template>
  <section class="hidden md:sticky top-20 z-40 bg-white rounded-2xl shadow-lg border border-gray-200 p-6 mb-8 backdrop-blur-sm bg-white/95">
    <div class="flex items-center justify-between">
      <div class="flex-1">
        <div class="flex items-center space-x-8">
          <template v-for="(step, index) in steps" :key="step.number">
            <!-- Step -->
            <div class="flex items-center space-x-3">
              <div
                class="w-12 h-12 rounded-full flex items-center justify-center transition-all duration-300"
                :class="{
                  'bg-green-500 shadow-lg shadow-green-500/30': isStepCompleted(step.number),
                  'bg-gradient-to-br from-blue-600 to-blue-700 shadow-xl shadow-blue-500/50 ring-4 ring-blue-100': isStepCurrent(step.number),
                  'bg-gray-200': isStepPending(step.number)
                }"
              >
                <span
                  v-if="isStepCompleted(step.number)"
                  class="material-symbols-outlined text-white text-2xl font-bold"
                >
                  check
                </span>
                <span
                  v-else
                  class="font-bold text-lg"
                  :class="{
                    'text-white': isStepCurrent(step.number),
                    'text-gray-400': isStepPending(step.number)
                  }"
                >
                  {{ step.number }}
                </span>
              </div>
              <div>
                <p
                  class="text-sm font-bold transition-colors"
                  :class="{
                    'text-green-700': isStepCompleted(step.number),
                    'text-blue-700': isStepCurrent(step.number),
                    'text-gray-400': isStepPending(step.number)
                  }"
                >
                  {{ step.title }}
                </p>
                <p
                  class="text-xs font-semibold transition-colors"
                  :class="{
                    'text-green-600': isStepCompleted(step.number),
                    'text-blue-600': isStepCurrent(step.number),
                    'text-gray-400': isStepPending(step.number)
                  }"
                >
                  <span v-if="isStepCompleted(step.number)">✓ {{ step.completedText }}</span>
                  <span v-else-if="isStepCurrent(step.number)">● In Progress</span>
                  <span v-else>Pending</span>
                </p>
              </div>
            </div>

            <!-- Connector Line (if not last step) -->
            <div
              v-if="index < steps.length - 1"
              class="flex-1 h-2 rounded-full transition-all duration-300"
              :class="{
                'bg-green-500 shadow-md shadow-green-500/20': isStepCompleted(step.number),
                'bg-gray-200': !isStepCompleted(step.number)
              }"
            ></div>
          </template>
        </div>
      </div>
    </div>
  </section>
</template>
